import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { useSession } from '@marriott/mi-headless-utils';
import { Image, RichText, Button, useWindowSize } from '@marriott/mi-ui-library';
import { MerchandisingPortalModalContent } from '../../molecules/MerchandisingPortalModalContent';
import { MerchandisingPortalModalProps } from './MerchandisingPortalModal.types';
import { StyledMerchandisingPortalModal } from './MerchandisingPortalModal.styles';

export const MerchandisingPortalModalComponent = (props: MerchandisingPortalModalProps) => {
  //const { mboxParameter } = props;
  const {
    isTargetContentLoaded = true,
    isTargetContentError = false,
    headerMedium,
    legalShort,
    logo,
    onCloseButtonClick,
    introCopy,
    destinationUrl1,
    callToActionText1,
    openInaNewTab,
    mathLabel1 = '',
    mathLabel2 = '',
    mathLabel3 = '',
    mathTitle = '',
    mathValue = '',
    mathType = '',
    preview_prop_currency_type = '', // this prop will be used by offers preview components, that only when there is no dataLayer[prop_currency_type] key
  }: MerchandisingPortalModalProps = props;

  const { datalayer } = useSession();
  const { width = 0 } = useWindowSize();
  const [variationDetails, setVariationsDetails] = useState({
    isVariationsAvailable: false,
    isPointsVariation: false,
    isCurrencyVariation: false,
    isNightsVariation: false,
  });

  useEffect(() => {
    if (
      isTargetContentLoaded &&
      ((mathType?.toLowerCase() === 'currency' &&
        (!!datalayer?.['prop_currency_type'] || !!preview_prop_currency_type)) ||
        mathType?.toLowerCase() === 'points' ||
        mathType?.toLowerCase() === 'nights')
    ) {
      setVariationsDetails({
        isVariationsAvailable: true,
        isPointsVariation: mathType?.toLowerCase() === 'points',
        isCurrencyVariation:
          mathType?.toLowerCase() === 'currency' &&
          (!!datalayer?.['prop_currency_type'] || !!preview_prop_currency_type),
        isNightsVariation: mathType?.toLowerCase() === 'nights',
      });
    }
  }, [isTargetContentLoaded, mathType]);
  return (
    <StyledMerchandisingPortalModal
      data-testid="merch-MerchandisingPortalModal"
      data-component-name="o-merch-MerchandisingPortalModal"
    >
      <div className={clsx(`merchandising-portal-modal t-background-color`, 'd-flex align-items-center flex-column')}>
        <div className={clsx('merchandising-portal-modal__image-container')}>
          {isTargetContentLoaded && (
            <Image
              customClass={clsx('merchandising-portal-modal__image')}
              dynamic={false}
              defaultImageURL={logo?.imageSrc}
              altText={logo?.altText}
            />
          )}
        </div>
        {width > 576 && (
          <div className="merchandising-portal-modal__badge-container">
            <Button
              className={clsx(
                'merchandising-portal-modal__badge icon-clear icon-l',
                'd-flex justify-content-center align-items-center p-1'
              )}
              callback={onCloseButtonClick}
            />
          </div>
        )}

        <MerchandisingPortalModalContent
          introCopy={introCopy}
          headerMedium={headerMedium}
          callToActionText1={callToActionText1}
          destinationUrl1={destinationUrl1}
          isVariationsAvailable={variationDetails.isVariationsAvailable}
          mathType={mathType}
          openInaNewTab={openInaNewTab}
          legalShort={legalShort}
          isTargetContentLoaded={isTargetContentLoaded}
          variationProps={{
            currencyType: (datalayer?.['prop_currency_type'] || preview_prop_currency_type) as string,
            currencyTotalStayAmount: parseFloat(`${datalayer?.['res_revenue_total_locale'] ?? '0'}`),
            pointsTotalStayAmount: parseInt(`${datalayer?.['mr_prof_points_balance'] ?? '0'}`, 10),
            currentEliteNightCredits: parseInt(`${datalayer?.['mr_prof_nights_booked_this_year'] ?? '0'}`, 10),
            isPointsVariation: variationDetails.isPointsVariation,
            isCurrencyVariation: variationDetails.isCurrencyVariation,
            isNightsVariation: variationDetails?.isNightsVariation,
            mathLabel1: mathLabel1,
            mathLabel2: mathLabel2,
            mathValue: mathValue,
            mathLabel3: mathLabel3,
            mathTitle: mathTitle,
          }}
        />

        <div
          className={clsx('merchandising-portal-modal__footer d-flex align-items-center flex-column', {
            'py-3': width > 576 && legalShort,
            'pt-3': width <= 576 || !legalShort,
          })}
        >
          {width > 576 && isTargetContentLoaded && legalShort && (
            <RichText
              text={legalShort}
              componentId="disclaimer-richtext"
              customClass={clsx('t-font-s mt-3 disclaimer-text text-center m-ellipsis-2lines')}
            />
          )}
        </div>
      </div>
    </StyledMerchandisingPortalModal>
  );
};

const MerchandisingPortalModalConfig = {
  emptyLabel: 'MerchandisingPortalModal',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/portalmodal`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MerchandisingPortalModal = (props: any) => {
  return (
    <EditableComponent
      config={MerchandisingPortalModalConfig}
      {...{ ...props, model: { ...props } }}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      children={<MerchandisingPortalModalComponent {...({} as any)} />}
    />
  );
};
